<template>
  <div class="mt-5 ml-2" v-if="src">
    <audio ref="audio" :src="src" controls>
      Your browser does not support this audio element.
    </audio>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
const VOLUME_KEY = 'lessons_audio_volume';

export default {
  name: 'audioPlayer',
  props: ['src', 'active', 'taking'],
  data() {
    return {
      currentTime: 0,
      audioTimeout: null,
      listening: false,
    };
  },
  watch: {
    active() {
      this.initAudio();
    },
  },
  methods: {
    initAudio() {
      if (!this.src) {
        return false;
      }

      let audio = this.$refs.audio;
      if (!audio) {
        return false;
      }

      if (!this.listening) {
        this.listening = this.bindListeners(audio);
      }

      if (this.audioTimeout) {
        clearTimeout(this.audioTimeout);
      }

      if (this.taking && this.active) {
        this.audioTimeout = setTimeout(() => {
          audio.volume = this.getVolume();
          // audio.currentTime = this.currentTime;
          audio.play();
        }, 1000);
      } else {
        audio.pause();
      }

      return audio;
    },

    bindListeners(el) {
      el.addEventListener('volumechange', () => {
        this.storeVolume(el.volume);
      });
      return true;
    },

    getVolume() {
      let defaultVolume = 0.75;
      let volume = 0;

      try {
        volume = sessionStorage.getItem(VOLUME_KEY);
      } catch (e) {
        console.warn(e);
      }

      return parseFloat(!volume || volume > 1 ? defaultVolume : volume);
    },

    storeVolume: debounce((volume = 0.5) => {
      console.log('storingVolume', volume);
      try {
        sessionStorage.setItem(VOLUME_KEY, volume);
        return volume;
      } catch (e) {
        console.warn(e);
        return false;
      }
    }, 500),
  },
  mounted() {
    this.initAudio();
  },
};
</script>
